import { CreateParams } from '~/api/scheme/lists';
import useListDialogs from './useListDialogs';
import { RowsData } from '~/hooks/table/useSelectedRows';
import { OpportunityJSONAPI } from '~/api/resources/opportunity';

const useCreditValidator = () => {
  const { openReviewCreditsDialog, openInsufficientCreditsDialog } = useListDialogs();

  const validateCredits = (
    syncType: string,
    listId: string,
    selectedOpportunities: (RowsData | OpportunityJSONAPI)[],
    totalCredits: number,
    creditPerOpportunity: number,
    createListParams?: CreateParams
  ) => {
    const opportunitiesToSync = selectedOpportunities.filter(
      (row) => !('attributes' in row ? row.attributes.synced_with_bpd_crm : row.synced_with_crm)
    );
    const requiredCredits = opportunitiesToSync.length * creditPerOpportunity;
    const selectedIds = selectedOpportunities.map((obj) => obj.id);

    if (totalCredits >= requiredCredits) {
      openReviewCreditsDialog(
        selectedIds,
        selectedOpportunities,
        listId,
        syncType,
        createListParams
      );
    } else {
      openInsufficientCreditsDialog(selectedIds, selectedOpportunities);
    }
  };

  return { validateCredits };
};

export default useCreditValidator;
